import React from 'react';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFilesForKnowledgeBase } from '../../../app/services/apiEndpoints';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

interface IFetchKBFilesPayload {
  group: string;
  index: string;
  kb: string;
}

export const fetchFilesForKnowledgeBase = createAsyncThunk(
  'modelSettings/fetchKnowledgeBaseFiles',
  async (payload: IFetchKBFilesPayload, thunkAPI) => {
    try {
      const queryParams = new URLSearchParams({
        group: payload.group,
        idx: payload.index,
        idxName: payload.kb
      });
      const response = await getFilesForKnowledgeBase(queryParams);
      return response;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

interface IModelSettingsState {
  currentSettingsContext: Record<string, any>;
  defaultSettings: any;
  resetModal: boolean;
}

const initialState: IModelSettingsState = {
  currentSettingsContext: {},
  defaultSettings: [],
  resetModal: false,
};

const ModelSettingsSlice = createSlice({
  name: 'model-settings',
  initialState,
  reducers: {
    setCurrentSettingsContext(state, action) {
      state.currentSettingsContext = action.payload;
    },
    setDefaultSettings(state, action) {
      state.defaultSettings = action.payload;
    },
    setResetModal(state, action) {
      state.resetModal = action.payload;
    },
  },
});

export const showConfirm = () => {
  return () => {
    return new Promise<boolean>((resolve) => {
      Modal.warning({
        title: 'Default Warning',
        icon: React.createElement(ExclamationCircleFilled),
        content: 'This is the default warning message.',
        onOk() {
          resolve(true);
        },
      });
    });
  };
};

export const { setCurrentSettingsContext, setResetModal, setDefaultSettings } = ModelSettingsSlice.actions
export default ModelSettingsSlice.reducer;